import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import ActivateStore from '../Fields/ActivateStore';
import DefaultWarehouseField from '../Fields/DefaultWarehouseField';
import OrderPrefix from '../Fields/OrderPrefix';
import StoreName from '../Fields/StoreName';
import TestConnectionButton from '../Fields/TestConnectionButton';

const BaseSalesChannelForm = ({ children, whRequired = false }) => {
	const {
		formState: { isLoading: isFormLoading, isSubmitting }
	} = useFormContext();

	const { salesChannel } = useSelector((state) => state.salesChannel);

	const isLoading = isFormLoading || isSubmitting;
	return (
		<>
			<StoreName isLoading={isLoading} />
			{children}
			<OrderPrefix isLoading={isLoading} />
			<DefaultWarehouseField isLoading={isLoading} required={whRequired} />
			<ActivateStore isLoading={isLoading} />
			{salesChannel.testable && <TestConnectionButton />}
		</>
	);
};

export default BaseSalesChannelForm;
